import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
/* eslint-disable @atlaskit/design-system/prefer-primitives */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

import React from 'react';
import styled from '@emotion/styled';
import { HEADER_HEIGHT, SECONDARY_NAV_WIDTH } from './constants';
export var SecondaryNavWrapper = function SecondaryNavWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Background, null), /*#__PURE__*/React.createElement(Wrapper, null, children));
};
var Background = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: fixed;\n  top: ", "px;\n  left: 0;\n  height: 100%;\n  width: ", "px;\n  background: #f4f5f7;\n"])), HEADER_HEIGHT, SECONDARY_NAV_WIDTH);
var Wrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: ", "px;\n  left: 0;\n  width: ", "px;\n"])), HEADER_HEIGHT, SECONDARY_NAV_WIDTH);